import { Dispatch } from 'redux';
import { firestoreDb } from './firebase';
import {
  FETCH_POLL_STATE_FB,
  SYNC_POLL_STATE_FB,
  RESULTS_VIEW_IS_BUBBLES,
} from './actions';
import { firestore } from 'firebase';
/*
 * dispatchers
 */

export const fetchPollStateFb = (dispatch: Dispatch) => {
  return firestoreDb
    .collection('polls')
    .get()
    .then((querySnapshot: any) => {
      let polls: any = {};

      querySnapshot.forEach((doc: any) => (polls[doc.id] = doc.data()));

      dispatch({
        type: FETCH_POLL_STATE_FB,
        polls,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const listenForScores = (id: string) => (dispatch: Dispatch) => {
  return firestoreDb
    .collection('polls')
    .doc(id)
    .onSnapshot(function (doc: any) {
      dispatch({
        type: SYNC_POLL_STATE_FB,
        id,
        data: doc.data(),
      });
    });
};

export const createPollFb = (id: string, owner: string) => async (
  dispatch: Dispatch
) => {
    try {
      await firestoreDb
        .collection('polls')
        .doc(id)
        .set({ owner, createdAt: new Date(Date.now()) })
        .catch((err) => {
          console.log(err);
        });

        return await fetchPollStateFb(dispatch);
    } catch(error) {
        console.log('Transaction failed: ', error);
    }
};

export const deletePollFb = (id: string) => async (
    dispatch: Dispatch
) => {
    try {
        await firestoreDb
            .collection('polls')
            .doc(id)
            .delete()
            .catch((err) => {
                console.log(err);
            });

        return await fetchPollStateFb(dispatch);
    } catch(error) {
        console.log('Transaction failed: ', error);
    }

};

export const updatePollScoresFb = (id: string, newScore: number) => async (
  dispatch: Dispatch
) => {
  console.log(
    `updatePollScoresFb dispatcher called "${id}" with score ${newScore}`
  );

  const pollRef = firestoreDb.collection('polls').doc(id);

  try {
    await firestoreDb.runTransaction((tx) =>
      tx.get(pollRef).then((poll) => {
        if (!poll.exists) {
          throw new Error('Document does not exist!');
        }
        const pollData: firestore.DocumentData = poll.data() as firestore.DocumentData;
        const scoreKey: string = new Date(Date.now()).toISOString();
        const newScores = {
          ...pollData.scores,
          [scoreKey]: newScore,
        };
        tx.update(pollRef, { scores: newScores });
      })
    );
    console.log('Transaction successfully committed!');
    return fetchPollStateFb(dispatch);
  } catch (error) {
    console.log('Transaction failed: ', error);
  }
};

export const setResultsViewIsBubbles = (swtch: boolean) => (
  dispatch: Dispatch
) => {
  return dispatch({
    type: RESULTS_VIEW_IS_BUBBLES,
    switch: swtch,
  });
};

export const createFollowUpFb = (
  id: string,
  score: number,
  contactDetails: number
) => async (dispatch: Dispatch) => {
  console.log(`createFollowUpFb dispatcher called "${id}" with score ${score}`);

  const pollRef = firestoreDb.collection('polls').doc(id);

  try {
    await firestoreDb.runTransaction((tx) =>
      tx.get(pollRef).then((poll) => {
        if (!poll.exists) {
          throw new Error('Document does not exist!');
        }
        const pollData: firestore.DocumentData = poll.data() as firestore.DocumentData;
        const followupKey: string = new Date(Date.now()).toISOString();
        const followups = {
          ...pollData.followups,
          [followupKey]: {
            contactDetails,
            score,
            isFollowedUp: false,
          },
        };
        tx.update(pollRef, { followups });
      })
    );

    console.log('Transaction successfully committed!');
    return fetchPollStateFb(dispatch);
  } catch (error) {
    console.log('Transaction failed: ', error);
  }
};
